import React from "react";
import "./index.css";
import ChatContainer from "./components/ChatContainer";
import { getRetrieval } from "./api/RetrievalsApi";
import { addMessage, addMessageAsync } from "./api/MessagesApi";
import { addFeedback, addFeedback2, matrixMode, addQuestionAsync, getChat } from "./api/QuestionsApi";

function App(props) {
  return (
    <div className="m-0 p-0 w-full h-full">
      <ChatContainer
          getRetrieval={getRetrieval}
          retrievalId={props.retrievalId}
          addQuestionRetData={props.addQuestionRetData}
          addMessage={addMessage}
          addQuestionAsync={addQuestionAsync}
          addMessageAsync={addMessageAsync}
          getChat={getChat}
          logo={props.logo}
          chat={props.chat}
          otherRefs={props.otherRefs}
          addFeedback={addFeedback}
          addFeedback2={addFeedback2}
          matrix_mode={props.matrix_mode}
          addMatrixMode={matrixMode}
          colors={props.colors}
          allow_files={props.allow_files}
          language={props.language}
          extendedReferences={props.extendedReferences}
          allowMetadata={props.allowMetadata}
        />
    </div>
  );
}

export default App;
